import { sortData } from 'helpers/sortData'

export function getSorted(value, order, domains) {
  switch (true) {
    case value === 'Sort by':
      return domains.sort(sortData(['attributes', 'createdAt'], order, value))
    case value === 'A-Z':
      return domains.sort(sortData(['attributes', 'host'], order, value))
    case value === 'Score':
      return domains.sort(sortData(['attributes', 'overview', 'score'], order, value))
    case value === 'Important Fixes':
      return domains.sort(
        sortData(
          [
            'attributes',
            'websiteAudit',
            'importantFixes',
            'fixes',
            'importantFixes',
            'value'
          ],
          order,
          value
        )
      )
    case value === 'Semi Important Fixes':
      return domains.sort(
        sortData(
          [
            'attributes',
            'websiteAudit',
            'semiImportantFixes',
            'fixes',
            'semiImportantFixes',
            'value'
          ],
          order,
          value
        )
      )
    case value === 'Pages Crawled':
      return domains.sort(
        sortData(['attributes', 'overview', 'crawledPages'], order, value)
      )
    case value === 'Checks Passed':
      return domains.sort(sortData(['attributes', 'overview', 'passed'], order, value))
    case value === 'Generated Date':
      return domains.sort(
        sortData(['attributes', 'overview', 'generatedDate'], order, value)
      )
    default:
      return null
  }
}
